import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=5df2f564&scoped=true"
import script from "./Conference.vue?vue&type=script&lang=ts"
export * from "./Conference.vue?vue&type=script&lang=ts"
import style0 from "./Conference.vue?vue&type=style&index=0&id=5df2f564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2f564",
  null
  
)

export default component.exports